var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from 'lodash/get';
import { getItem } from 'conversional-persistent-storage';
import { addStylesToRootLauncher, appendChild, appendToRoot, createElement, getRootLauncher } from './utils';
import { addCloseIcon, addLoadingIndicator, LAUNCHER_HIDE_KEY } from './general';
import { textLauncherStyles } from '../styles/textLauncher.styles';
var PREFIX_CLASS = 'text-launcher-';
var getPrefixedClassName = function (className) { return "".concat(PREFIX_CLASS).concat(className); };
export var TEXT_LAUNCHER_FONT_STYLE_ID = 'conversional-text-launcher-font';
var ARROW_ICON = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
export var renderTextLauncher = function (loader, theme) {
    appendToRoot(createTextLauncherContainer(loader, theme));
};
export function createTextLauncherContainer(loader, theme) {
    var styles = textLauncherStyles(theme, __assign(__assign({}, loader), { fontFamily: getLauncherFontFamily(loader, theme) }));
    addStylesToRootLauncher(styles.textLauncherRoot);
    var container = createElement({
        uniqueId: getPrefixedClassName('container'),
        styles: styles.textLauncherContainer,
    });
    if (!container)
        return null;
    if (getItem(LAUNCHER_HIDE_KEY))
        getRootLauncher().style.display = 'none';
    var closable = loader.closable, reloadOnClose = loader.reloadOnClose;
    closable && addCloseIcon(container, { reloadOnClose: reloadOnClose, styles: styles.closeIcon });
    addLoadingIndicator(container, { styles: styles.textLauncherLoading });
    var body = createElement({
        styles: styles.textLauncherBody,
        attributes: { role: 'text-launcher-body' },
    });
    appendChild(body, createElement({ styles: styles.textLauncherTitle, innerHTML: loader.title || loader.labelPreview }));
    loader.message && appendChild(body, createElement({ styles: styles.textLauncherMessage, innerHTML: loader.message }));
    loader.showArrow !== false && appendChild(body, createElement({ styles: styles.textLauncherArrow, innerHTML: ARROW_ICON }));
    appendChild(container, body);
    return container;
}
// The launcher lives on the host page, so the journey's font has to be loaded there too
export function getLauncherFontFamily(loader, theme) {
    if (loader.fontFamily)
        return loader.fontFamily;
    var font = get(theme, 'typo.fonts.bold') || get(theme, 'typo.fonts.regular');
    if (!(font === null || font === void 0 ? void 0 : font.fontFamily))
        return undefined;
    if (font.src && !document.getElementById(TEXT_LAUNCHER_FONT_STYLE_ID)) {
        var style = document.createElement('style');
        style.id = TEXT_LAUNCHER_FONT_STYLE_ID;
        style.textContent = "@font-face{font-family:'".concat(font.fontFamily, "';font-style:").concat(font.fontStyle || 'normal', ";font-weight:").concat(font.fontWeight || 'normal', ";font-display:swap;src:").concat(font.src, ";}");
        document.head.appendChild(style);
    }
    return "'".concat(font.fontFamily, "', 'Roboto Regular', sans-serif");
}
